<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="commentId" >
        <span slot="label" >
          <a-tooltip>
            所属评论ID<template slot="title">所属评论ID</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.commentId"  :placeholder="$t('请输入')+'所属评论ID'" />
      </a-form-model-item>
      <a-form-model-item prop="postId" >
        <span slot="label" >
          <a-tooltip>
            帖子ID<template slot="title">帖子ID</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.postId"  :placeholder="$t('请输入')+'帖子ID'" />
      </a-form-model-item>
      <a-form-model-item prop="replyUserId" >
        <span slot="label" >
          <a-tooltip>
            回复人ID<template slot="title">回复人ID</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.replyUserId"  :placeholder="$t('请输入')+'回复人ID'" />
      </a-form-model-item>
      <a-form-model-item prop="replyUserName" >
        <span slot="label" >
          <a-tooltip>
            回复人昵称<template slot="title">回复人昵称</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.replyUserName" :maxLength="100" :placeholder="$t('请输入')+'回复人昵称'" />
      </a-form-model-item>
      <a-form-model-item prop="content" >
        <span slot="label" >
          <a-tooltip>
            回复内容<template slot="title">回复内容</template>
          </a-tooltip>
        </span>
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item prop="isAuthorReply" >
        <span slot="label" >
          <a-tooltip>
            是否作者回复：1-是，0-否<template slot="title">是否作者回复：1-是，0-否</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.isAuthorReply"  :placeholder="$t('请输入')+'是否作者回复：1-是，0-否'" />
      </a-form-model-item>
      <a-form-model-item prop="parentReplyId" >
        <span slot="label" >
          <a-tooltip>
            父级回复ID<template slot="title">父级回复ID</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.parentReplyId"  :placeholder="$t('请输入')+'父级回复ID'" />
      </a-form-model-item>
      <a-form-model-item prop="remark" v-if="formType === 1">
        <span slot="label" >
          <a-tooltip>
            备注<template slot="title">备注</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDiscoveryReply, addDiscoveryReply, updateDiscoveryReply } from '@/api/discovery/discoveryReply'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";

import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    Editor
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        commentId: null,

        postId: null,

        replyUserId: null,

        replyUserName: null,

        content: null,

        isAuthorReply: null,

        parentReplyId: null,

        createTime: null,
        localeFieldMap:{},

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        commentId: [
          { required: true, message: '所属评论ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        postId: [
          { required: true, message: '帖子ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        replyUserId: [
          { required: true, message: '回复人ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        replyUserName: [
          { required: true, message: '回复人昵称'+this.$t('不能为空'), trigger: 'blur' }
        ],
        content: [
          { required: true, message: '回复内容'+this.$t('不能为空'), trigger: 'blur' }
        ],
        isAuthorReply: [
          { required: true, message: '是否作者回复：1-是，0-否'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        commentId: null,
        postId: null,
        replyUserId: null,
        replyUserName: null,
        content: null,
        isAuthorReply: null,
        parentReplyId: null,
        createTime: null,
        localeFieldMap:{},
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDiscoveryReply({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateDiscoveryReply(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addDiscoveryReply(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
